
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexsaJpE__FMo93XAiBU_45GtbZso0CouVKfXv88bnqgq0fkMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/index.vue?macro=true";
import { default as loginN5tfmZTQfaApxwN0kxSbuKuKItgjfcUIrdGftKqkglAMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/login.vue?macro=true";
import { default as mgenQYlm_45LETnH0GDMXCqJD84i8ggc2XIN70Z_bTJQ_qJ6AMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/mgen.vue?macro=true";
import { default as indexctOWnKhlvg167wA_45Y_45QsFOnAsEwpelHOG2iNDqQpFjEMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/index.vue?macro=true";
import { default as notesOxZZRAO4LQVBoNNRTqUby43_CP14qqSdHyHSv7Wew7oMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/notes.vue?macro=true";
import { default as indexxQ6IL4KFZhw_OkTyKRuxTetNCG8YgbBJPC186h3x7jIMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentqBdFT4tJ1JiH8am4mBCDjljhaxgQoy0Jql60sfKa2pMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteMEM02biYVuZNBQNSJz2xU0SJlevJHQxjlqLJxzTWBowMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/plan-du-site.vue?macro=true";
import { default as editABONxYJEIJwsZI1_45f0fl4cLn40EncaEDp6rq0zdugikMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/edit.vue?macro=true";
import { default as placesb9aLtBcX0eOofm9cA2mrbvLRc0mVG8p55oOwuMOVEoMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/places.vue?macro=true";
import { default as accessibiliteWguQaHPs7jm_85incriO_45pi8TjNeCX5I5Vcqj7iWO54Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/accessibilite.vue?macro=true";
import { default as _91id_93pJpiS67Kl8hFopqgNW2d2AD_Lq2_453CuV3I0yTUnP140Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/[id].vue?macro=true";
import { default as notificationsnbMr7mPjhKVxV5LDGWIRZp9akxw_VuEtnFkjLTvRXToMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/notifications.vue?macro=true";
import { default as indexdx91Gp_45HZEcCpZIiClL7py6VhEvk1PJzT15jbEAYYrIMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/index.vue?macro=true";
import { default as indexq3XH3_45Gf0YiIMuiWVRMbJ1IvWhWeZ2Cx6JnG9mjB4nQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/index.vue?macro=true";
import { default as _91slug_93pgc77MgGpzKNFZw17ot_jXnHyKcJjvQeit7uShQDkrAMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/villes/[slug].vue?macro=true";
import { default as index_45Ae_4539y0X4pNtpIqSDI2iBGOlzjXW0PJI4BnLIa_45T3sMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/index.vue?macro=true";
import { default as generiqueoZ7chtXvoSL8sUnG_RrPHJh2GZG7nEKO0imtg_tCiScMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93Raf9Y_45H0J12daVrn3vKlxaiBIWc3NhFGu1dI_45Io8SQYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/reseaux/[slug].vue?macro=true";
import { default as missions9XPctsBFOJzjZ0kbn9tAfz7sWVcludleJQeo5endRGkMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/missions.vue?macro=true";
import { default as indexWxvSpp63rNx3i_45HNUMoEHwu5CuKxB_yKgvZ2w4mYs0EMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/dashboard/index.vue?macro=true";
import { default as favorisAq9NyT5jVvuAD7kj_45kVUeemN_454F0PkTmSvUjGDk6WKMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/favoris.vue?macro=true";
import { default as _91slug_933r6IdLNdZtSkVJHy4ko0hxvOsJAWjpYfb_MJuY21z_45YMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/activites/[slug].vue?macro=true";
import { default as logszOQAl7NV2mhPH_GWJFxycvD79iLts2x_450eqSkn0YHpIMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesxKwlDJmYo_45cE0KcftkIB6wuQwOPAykcgpwGv7LCcL8wMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesQD5pJ2kxV3BvJbEFhff4qUEdHNShh_GX7U2_45oS3_45chUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/mentions-legales.vue?macro=true";
import { default as missionsTxPbYT1uBdAcROyO4lxstUsV1vcc4ZfnCTMcg_PEQOUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/missions.vue?macro=true";
import { default as settingsjw7nAPj1rQAJBo1zWwGnFrFW9cZhOhdwlRwok578FfMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/settings.vue?macro=true";
import { default as tournee_45etev_cOWeiHDakselSgC_LTWFFXDUREm_45zmt8GfgLtRMlcMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignagesiBoVQ50n61frI9FykFSCYux4edz9epvm7xXRQ6J5egkMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/temoignages.vue?macro=true";
import { default as indexZaoWgIsH9iHZFC3dm7FjKqRg1X_45eagOta0r51S0W3Y8Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/index.vue?macro=true";
import { default as adminAuQHhxTOvDBvVAvZWL9uvdbkCHoI6ra0ayC_45lil8RBEMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/maintenance/admin.vue?macro=true";
import { default as indexqagLPsxEAFEMUq5x2rPWMEtReB7boDbqz364mqVjdUMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/maintenance/index.vue?macro=true";
import { default as index_45qXLMR6ksUbCvF053q0VTvaltg8v_45fZHFiTXqBp_E_UMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/territoires/index.vue?macro=true";
import { default as _91hash_93daU5f39kKlNVGP96ittong1bcBPqc6WJo4oexDYFQyUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/invitations/[hash].vue?macro=true";
import { default as utilisateurs750nX8vxEDW1x9vHlEZr0MkihH_45NkFhzv_sw_0jaGQUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93xii6RtQf464lJjcxJ0AZS3oCcPjVaLE05x15eN0r2wYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93HexzeyHfwMXAdmMfgKI53owCqYWSX2loU9fYIUrJRN8Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/departements/[slug].vue?macro=true";
import { default as indexSbVmQJN9PaKSKDZUMzc_45iVfpsVsnfDiEK79Wop6ita0Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/organisations/index.vue?macro=true";
import { default as preferencesFjRgfaVBbDqv_aAC_454BahRy8DlzK9sUbVy3AOh6BquYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/preferences.vue?macro=true";
import { default as organisationsF7c4tpjGkuOAxbI5OdTZzN3bZZaFAvoRJ60qmOq3szQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/organisations.vue?macro=true";
import { default as _91token_93F8O3KBlzLcjB1b1WTUMOT16cfx79XDryrUSpugziJN4Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/temoignages/[token].vue?macro=true";
import { default as posts_Qu_45X8Ti5K_vTVQZYA9zr_ada0Nvq6vM0WbxS85LH3sMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/posts.vue?macro=true";
import { default as index7LA7T8LfJepBF5kNanXd9Wp_lETr_tcnvZVoI6l_45OTsMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/index.vue?macro=true";
import { default as addxNG5B3Vpb10pcVLS33D84OfuRdGHRoAoOuPmyJVp3awMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_935vDVCBZoKZZKB4o7p4_459Sk4RASi84W_45ez4f9ndqOEPgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/organisations/[slug].vue?macro=true";
import { default as indexLPwuFPusHdGtUQKx04a7AYte3uwT2BYso6Q9WRdBwGAMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/password-reset/index.vue?macro=true";
import { default as participationsEpJdJYANjmuvs19Pl5AsmGEd04wMIk71j_45zV0O8rIqMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/participations.vue?macro=true";
import { default as emailsYdzMK7yBIIBEj_DfkHe7Z5amt4M9QDi3NEb9OIkJt94Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/emails.vue?macro=true";
import { default as indexm2jq5lfLkosdl6wKkXyc_45glWhKO4lNjtVIHc_45tS5kJYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsdF5gVDAjyQWUdFQVobV9OHkBoEC1nKWrZm0ZhVjfPhgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/notifications.vue?macro=true";
import { default as indexE08WVZZOozSV_45HKUhjjGi8t53jLzCZTJHdq0Q7xJZ_0Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civique5lDbf_c15EisWlkR5Y1oN_zbW9gohWn6GV6_uB9gw1kMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93ZxlCCJoNCK1DVbfTxeShC7MHKEvHSo0qtfUtgZU28KcMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/domaines-action/[slug].vue?macro=true";
import { default as indexOUsKd1vDdKWdaBtStrwZjkoo7AMn_UHd0yuttA_i_dMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93WsTTBmuSIxHspBBKQQpQRBt6KHcL5C8oQJ0ObKgluWQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemblegSle4GGPF5MlYfTJSvpJghaCViDc5rE8N5WQ8Vq1GQwMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsa4NA5mCvCPHbb_sLcp9CLskdHke5THZPkGtC6nHJNWgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/other/invitations.vue?macro=true";
import { default as messagesQrBSPDCMT8Vowf_f_45OSqUMiBHVLBoTxLMUfE2dR4XF8Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/messages.vue?macro=true";
import { default as placesIrTicYuQ__45LlJd7zhpBp_iIW_45ZzHbhyK5LSyh2Ceb_YMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/places.vue?macro=true";
import { default as adde_HHUNI_45ml_63qQR_LylGtF_45FZfA3o2z78n6saqLKDYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexbkj96aZOhoqURP9EmRxy9pOVYyTG194uL3YGx1BOOboMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexTJCDnm_45BMgl2MCifVmbSc0RD3cHO72nIIIsBriqnFckMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/missions-benevolat/index.vue?macro=true";
import { default as datesm4ogAw3lGZHhouMTO3ZM2jn62fnwwIKr9RNM1XvN0xUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexbUtTO4h0wJQdFcvXU3R9H5RfJo5qXke4G5MxZ9PB95kMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxlXyK0MjQ7_45RJas18znipGWS1ffbSwYr_45e_jbUEuR_Y4Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as title2vENZcgaoES01IGQICs5_45sfYiKIP3xoxnGrYg9vY4NQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexwcscSWvfnSWQAe8M6DWOHg2eLqAxcW72y3KFKa1vj5AMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/index.vue?macro=true";
import { default as missionspqrTIrO4gP3OUGqmKjQpASKiwY4jPJJzEf02qiXoHOkMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/missions.vue?macro=true";
import { default as add2Ldn0VVUMeS014lMjMgSOiCgNgzsuJyr_EO65MGzWi4Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelilhw1cVXmyVeSOmOSexeprGKIHRE99imc8uGQdcfzsoMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexurqLCJ8zXtazat9HLjaYGfcyg3IL0V_DXAHvSHOjZAoMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/participations/index.vue?macro=true";
import { default as indexZewxy4WKfDWIHftBm1FHWhquyvTlFzILMDO4k20f5FMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexb_45WPjTV3FfkdG4pMAFv2uQ2dZVorR9YpQUKJP6_45KZYMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/index.vue?macro=true";
import { default as addQanNhUCkqIZ1jpi1BAzzDbbP1_uMtMJBhrkKWtQPe_MMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as add89guJWOd1JVXs4srD73xezKvA9_45vIl4pzaIU_45sZoQtsMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addiRGhj30Fx7K2b2tdFEud_45wS2Manwv8IkeqAcH8v__EoMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexyNLr7z_I9QiBayW7JnYHLqBT5T_0sn8ORI9rG45LURoMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsbKMW2ackO_kHAJRnQsd3WYFvuEw1VjzGwbARX8WdEW0Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/conversions.vue?macro=true";
import { default as editMlGLiot6vQud_45IvwO3GqckVeut7KBJPIW3RH2sA6b6kMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteGQe89SvedANYa_4509A0a41sMag_4vffNPIhmrykSWYgkMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexl6jCkBGRLNz_45s2V8w2jvZJBgeL4g1V_C0xq6cu5XcH0Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addzPwAZD92hvaqKddLMK8vsy5XlshX6qTQKpxRxRQ3k3oMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesv5X7DThqcrSrDCKNQHZrG4_457y3pZhEQr2M_Ntj4fSmIMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editrGl34LO_y9YQ2D30Xjrt84AlHLHxLlm7Bc_45xb7PXk7gMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateurs98pO2LnovrNCRR_45mIkxFegDlKSqNhrv3_4Ti9TcNKLkMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexDimgZ_45wA8bTeHjGOgW9eq9GFkYPRHFpk8qH5Errb604Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexn7_45dB__45WjHMzR4Xv650Sl_b_2NrwWr0GWzZd92iGCe4Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexsUtn7og0kLVLkN4Vn905uLZ6TFFpIKc4KSoCFt8bAhQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/index.vue?macro=true";
import { default as indexs_45yJm_4wgXGoe2hKTEnwa_XVtTkYA9IKOe_zJuU1wf0Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendrepxXnxrtDbjUFH4EIwLvmI3uMKGFli1fPERdS37m28ckMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexUAdsjLVYBKke_45Adk01M368usX2208gmhOIgCnNafAU0Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addeBYN6S69VdESsJnTlVfD4cm7LokekI3ogwdYCt5fdZYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexD2UFbp2Yb0_GLs6OQEq6Z3ylXivY3ECvacKNWFGKStMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editHUiK6_45rTl64nfffwGeMUlBnOi4RKjREEgaZRFk6MCdgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93yBAYAAuw72NRUQ_45C8ahK3ifOL23PR_jCi5sDZSXPtwUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planetehN2Uprsh_452tQ7HTqy55SmgVVi48E287AiKZ8m0BrN_45kMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexAJwcTg7kczS8BmF75ejielFOUw5dbpWZ5ERpyOx5zY8Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsAVZpKO9PczkyhLrr3gWlL_yy_45SfDHep_Y3_ruko1TDQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/participations.vue?macro=true";
import { default as index96NCpARunP_45ZFjYbjzK9zORUmXoQwoJI0rdxaAh2uQMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsy5Rfl8PLdeX4MLNxleZIcDYOjmhDLJZkNBfK7_45rChK4Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/referents/activity-logs.vue?macro=true";
import { default as editMM0Bpj_45meaIMQWmbzPqUuW0RYtPyb6PnNQI4bC0vXNUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexMtrRS4PdpvWn6TMRiW2ESnP49tjlOMl_451JbB6iFLk68Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsYwDStB3PWsaQA2UnADFCiu7lGKO8Qx4TZdHuqld_45BZwMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesGnZUZn1EI2jNNrkLFtgQMhnaV0JfA2e3HDALwPkKDTsMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editP2R834CiMvQX_45G58_Y_45AfTB0HlcZr7JniXS3xhjH3EgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexDUW5U6SF8QeuC1OERkR5Y9TyFfkBpYTyzUbWNPrQEbEMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexD2wIh30Uj_avqTKCpzobZjVHVEJaaRHMMdJFMlZo6ooMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesxf_oFCogOyqa7JyqUgJfTpGQcCD8nxbZfzGXCCETlxQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editJspedUKqm1J_45oXFhNry63dhLMMISgDVnhYzL23m0oMMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profileFO4IGg4c99fogJediWJRrnEQJYVVlw0CunSqcniN2loMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementpUAc9xJ6NQcY4NfQcAX7HI8WAUR4uSCiNbcTNC_45fEyAMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actions2wHMBqtiTBrb_45pkjqOhPN8NSMULOdWx47sQznBcXYVAMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editfJoN99I_e_08JaCMH29aCj9Fxk2ol60PfA6D_45xVpuoEMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as add6DS4WJWg_4519l0UfD8Ixlu4tKJtJj_45xOJf8I7T_45s5kroMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationGZCo3Dq57PHW_45KInYVNrZwi_va7MmKi9UrP35zHRzdYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexJ8wMmCboWYu7CFq1eruu_S7ljnWU9XbmtFgvFADvGdYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editXP_ZGrFrL9WCgKUKqprGRh76PN7O4Mk49JKCe5zUJ8YMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsHB8UxlbWfvqk72w1fPHdNaxH8d5xZFu65ewR_45FjC4pgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsIZtQkkXh3S5fMry1fCHOP9UyWmeUJeRFCcZFnfEF7vgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesvt5XFRoGSzOF86zVnn01lzX0vhzbL2td934cPl_45oGH8Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexinge1tEZUoetaMjt68Sh_45Y3uoRkGtIFq8sMo_of7pEhodgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as index_wcHEA2GdROFSOOYF6Zp7TgeRJXF61tHx7q4cg4CecQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editzDVOUzuQXRhN0_M2IJqe3L25u37d8CHsYkwpLgKP1g4Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexzpa3HvlmozQ39eX_IfQWPAMPOsyAbVY1INh8crEgHvQMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileZylerq96mq1EOr7q7YssNvGbdgUiPy_xoIa0GaBHNIYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexTfqeteASqnwCXMKK9IfAfw0qmGiSq_T8QqG5wP4oKhwMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editefFm_esEXHFIl1xPctCIKrzQkCSNIHebhK8Wth70YsAMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addT4sHBIFzYoqSoWR4_45QWeCgQi3_45ntExQH6vV__1J5oJ8Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competences6T_WcZQU_45k_yY3hAwaStXv1HHfxlgHdvgfC1I1qUDUgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferences83wyYDfGnRgJDaWBSYH4vEMAvmkO_45GA2ayq3D7YN7SEMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45userstgWWGIyUXGpVcUKKx9SCJThDTS0x9tcm4DcbHTjNbPYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresjREuRju4p5VCrXBo944v7SY3EbAGEChs30MPS5_45p6aoMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesdqjllM8_HmRd_45Ynru0Ni_45JCCDrq04h_45IBgU_45ivy_45tqcMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationnVpeBO743OBABCmP6a_456XVVsjPyqFMlaKHb5CnEF55YMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedTMdTJoNtuzO6Zf_FiTzptfvNprgLsuttHVKbzID_458YYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsxLI3ZeiD40bquyfxIX_45j3UOCOYlv1ub_6DzK2wRzNLwMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45roley62Z2DqU7HSHmVa2eCItVsMEF63hnuYu9sM4LEPsbscMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsbgE7DbV3h3PV_45TZuzIXjoFqocbQ8rnUCzDJL3pDfcDwMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editERaGqDAe_RiUBI7Q2_wIv9gkTpbl2F9L7ZhI3TVYGUcMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilites3LuUhhrTQVscjvcd9yLJg_SLh1ddKrf_45h22IgqFUxdEMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45link8T_45wvxKSqNKKFwfWLkf3rgty56Letp1sLCaiVFNlcfEMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as index9d_45C4MDyypT5HEjgEgRR3mj5seXpwTGd_45jqd7jHn0VgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivitegQ4dSZzNbkbbSpWUI19YsO9WYpQXiwlvlU_45AqY34JmYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationOShYUV1_gnPpsPLG7jnjlJB70O4jIMNjOuUWYO8oTXcMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsaojBh9u1z74ekbtyZa4Epr4OWQQAfUM4mFFyk5vfvqYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entranti3CjkxZXdmHQI5v1g3yZ_DpLINWH9qXA7IK2ph7_UVUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortant_HbgiJYl9n_ro0IOlKel0MI5JNO6SPf7glDDq6GaJIYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexBFRsi0hyYLDEr1ZK9i1EMYrpCPxYDDlWWgnLRQFpvDsMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesiFq3DOSkeHJPOquE8yWI_0uqzeRWhaCJVLd907Nff9oMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45valider96iQuc8O6RhBeF7kufDOQI1bzC_45SyCaB9Yqzm28osSMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesxhsWIrK2o7cl6uJc5WPjG_2t0uybUlbr0fyaa9s7RLUMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesXfH_45Oy9VWSMCySlQduA08ACiPbHk0Q8CeK3IfzG_45ktMMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsiCgiGxHEZKTwwwencdIRKMFqbLj_WiPwlm0PvClcGPgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedMfdX7Q9QvZWT2y6sRWRhNi8G_45T8Sg3_Iaw8MEn_VHZwMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirect8p_oAzmzT1g8WUHq_9S3f5nfDQ39q80bkWH0r4CtEyYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerwYX7hAzQvwd_45qDDHs4yF06e8vD51_45JCxLULM7tg1raoMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementeivIQrGtEsou_45mM6UEeNbha_xVugNaNQRs33HPmfU58Meta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationIgfh2vHvhp8bSOTMGA_452IviKRj_451cn2F5UMnWSwZXkgMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationZv__DPWykkLdqTRDj2ov5iA0Q2jXlPiM_tXYxCp5s7EMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45valider_Ol_45aJ7INzXz6FpSvxs1EtwV9LjXy952vwDow38sVrwMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleeslDJWCuUv3sXoBysNTNU5Ps2fpUIsmTTX8TmNPhB1yeYMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk } from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginN5tfmZTQfaApxwN0kxSbuKuKItgjfcUIrdGftKqkglAMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenQYlm_45LETnH0GDMXCqJD84i8ggc2XIN70Z_bTJQ_qJ6AMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexctOWnKhlvg167wA_45Y_45QsFOnAsEwpelHOG2iNDqQpFjEMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesOxZZRAO4LQVBoNNRTqUby43_CP14qqSdHyHSv7Wew7oMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexxQ6IL4KFZhw_OkTyKRuxTetNCG8YgbBJPC186h3x7jIMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editABONxYJEIJwsZI1_45f0fl4cLn40EncaEDp6rq0zdugikMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesb9aLtBcX0eOofm9cA2mrbvLRc0mVG8p55oOwuMOVEoMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93pJpiS67Kl8hFopqgNW2d2AD_Lq2_453CuV3I0yTUnP140Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsnbMr7mPjhKVxV5LDGWIRZp9akxw_VuEtnFkjLTvRXToMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexdx91Gp_45HZEcCpZIiClL7py6VhEvk1PJzT15jbEAYYrIMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexq3XH3_45Gf0YiIMuiWVRMbJ1IvWhWeZ2Cx6JnG9mjB4nQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: index_45Ae_4539y0X4pNtpIqSDI2iBGOlzjXW0PJI4BnLIa_45T3sMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueoZ7chtXvoSL8sUnG_RrPHJh2GZG7nEKO0imtg_tCiScMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93Raf9Y_45H0J12daVrn3vKlxaiBIWc3NhFGu1dI_45Io8SQYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missions9XPctsBFOJzjZ0kbn9tAfz7sWVcludleJQeo5endRGkMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexWxvSpp63rNx3i_45HNUMoEHwu5CuKxB_yKgvZ2w4mYs0EMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisAq9NyT5jVvuAD7kj_45kVUeemN_454F0PkTmSvUjGDk6WKMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logszOQAl7NV2mhPH_GWJFxycvD79iLts2x_450eqSkn0YHpIMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsTxPbYT1uBdAcROyO4lxstUsV1vcc4ZfnCTMcg_PEQOUMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsjw7nAPj1rQAJBo1zWwGnFrFW9cZhOhdwlRwok578FfMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45etev_cOWeiHDakselSgC_LTWFFXDUREm_45zmt8GfgLtRMlcMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexZaoWgIsH9iHZFC3dm7FjKqRg1X_45eagOta0r51S0W3Y8Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminAuQHhxTOvDBvVAvZWL9uvdbkCHoI6ra0ayC_45lil8RBEMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexqagLPsxEAFEMUq5x2rPWMEtReB7boDbqz364mqVjdUMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93daU5f39kKlNVGP96ittong1bcBPqc6WJo4oexDYFQyUMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateurs750nX8vxEDW1x9vHlEZr0MkihH_45NkFhzv_sw_0jaGQUMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesFjRgfaVBbDqv_aAC_454BahRy8DlzK9sUbVy3AOh6BquYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsF7c4tpjGkuOAxbI5OdTZzN3bZZaFAvoRJ60qmOq3szQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93F8O3KBlzLcjB1b1WTUMOT16cfx79XDryrUSpugziJN4Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: posts_Qu_45X8Ti5K_vTVQZYA9zr_ada0Nvq6vM0WbxS85LH3sMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: index7LA7T8LfJepBF5kNanXd9Wp_lETr_tcnvZVoI6l_45OTsMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addxNG5B3Vpb10pcVLS33D84OfuRdGHRoAoOuPmyJVp3awMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_935vDVCBZoKZZKB4o7p4_459Sk4RASi84W_45ez4f9ndqOEPgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexLPwuFPusHdGtUQKx04a7AYte3uwT2BYso6Q9WRdBwGAMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsEpJdJYANjmuvs19Pl5AsmGEd04wMIk71j_45zV0O8rIqMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsYdzMK7yBIIBEj_DfkHe7Z5amt4M9QDi3NEb9OIkJt94Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexm2jq5lfLkosdl6wKkXyc_45glWhKO4lNjtVIHc_45tS5kJYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsdF5gVDAjyQWUdFQVobV9OHkBoEC1nKWrZm0ZhVjfPhgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexE08WVZZOozSV_45HKUhjjGi8t53jLzCZTJHdq0Q7xJZ_0Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexOUsKd1vDdKWdaBtStrwZjkoo7AMn_UHd0yuttA_i_dMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93WsTTBmuSIxHspBBKQQpQRBt6KHcL5C8oQJ0ObKgluWQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemblegSle4GGPF5MlYfTJSvpJghaCViDc5rE8N5WQ8Vq1GQwMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsa4NA5mCvCPHbb_sLcp9CLskdHke5THZPkGtC6nHJNWgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesQrBSPDCMT8Vowf_f_45OSqUMiBHVLBoTxLMUfE2dR4XF8Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesIrTicYuQ__45LlJd7zhpBp_iIW_45ZzHbhyK5LSyh2Ceb_YMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: adde_HHUNI_45ml_63qQR_LylGtF_45FZfA3o2z78n6saqLKDYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexbkj96aZOhoqURP9EmRxy9pOVYyTG194uL3YGx1BOOboMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexTJCDnm_45BMgl2MCifVmbSc0RD3cHO72nIIIsBriqnFckMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesm4ogAw3lGZHhouMTO3ZM2jn62fnwwIKr9RNM1XvN0xUMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexbUtTO4h0wJQdFcvXU3R9H5RfJo5qXke4G5MxZ9PB95kMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxlXyK0MjQ7_45RJas18znipGWS1ffbSwYr_45e_jbUEuR_Y4Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: title2vENZcgaoES01IGQICs5_45sfYiKIP3xoxnGrYg9vY4NQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexwcscSWvfnSWQAe8M6DWOHg2eLqAxcW72y3KFKa1vj5AMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionspqrTIrO4gP3OUGqmKjQpASKiwY4jPJJzEf02qiXoHOkMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: add2Ldn0VVUMeS014lMjMgSOiCgNgzsuJyr_EO65MGzWi4Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelilhw1cVXmyVeSOmOSexeprGKIHRE99imc8uGQdcfzsoMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexurqLCJ8zXtazat9HLjaYGfcyg3IL0V_DXAHvSHOjZAoMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexZewxy4WKfDWIHftBm1FHWhquyvTlFzILMDO4k20f5FMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexb_45WPjTV3FfkdG4pMAFv2uQ2dZVorR9YpQUKJP6_45KZYMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addQanNhUCkqIZ1jpi1BAzzDbbP1_uMtMJBhrkKWtQPe_MMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: add89guJWOd1JVXs4srD73xezKvA9_45vIl4pzaIU_45sZoQtsMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addiRGhj30Fx7K2b2tdFEud_45wS2Manwv8IkeqAcH8v__EoMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexyNLr7z_I9QiBayW7JnYHLqBT5T_0sn8ORI9rG45LURoMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsbKMW2ackO_kHAJRnQsd3WYFvuEw1VjzGwbARX8WdEW0Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editMlGLiot6vQud_45IvwO3GqckVeut7KBJPIW3RH2sA6b6kMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexl6jCkBGRLNz_45s2V8w2jvZJBgeL4g1V_C0xq6cu5XcH0Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addzPwAZD92hvaqKddLMK8vsy5XlshX6qTQKpxRxRQ3k3oMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesv5X7DThqcrSrDCKNQHZrG4_457y3pZhEQr2M_Ntj4fSmIMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editrGl34LO_y9YQ2D30Xjrt84AlHLHxLlm7Bc_45xb7PXk7gMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateurs98pO2LnovrNCRR_45mIkxFegDlKSqNhrv3_4Ti9TcNKLkMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexDimgZ_45wA8bTeHjGOgW9eq9GFkYPRHFpk8qH5Errb604Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexn7_45dB__45WjHMzR4Xv650Sl_b_2NrwWr0GWzZd92iGCe4Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrepxXnxrtDbjUFH4EIwLvmI3uMKGFli1fPERdS37m28ckMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexUAdsjLVYBKke_45Adk01M368usX2208gmhOIgCnNafAU0Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addeBYN6S69VdESsJnTlVfD4cm7LokekI3ogwdYCt5fdZYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexD2UFbp2Yb0_GLs6OQEq6Z3ylXivY3ECvacKNWFGKStMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editHUiK6_45rTl64nfffwGeMUlBnOi4RKjREEgaZRFk6MCdgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planetehN2Uprsh_452tQ7HTqy55SmgVVi48E287AiKZ8m0BrN_45kMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexAJwcTg7kczS8BmF75ejielFOUw5dbpWZ5ERpyOx5zY8Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsAVZpKO9PczkyhLrr3gWlL_yy_45SfDHep_Y3_ruko1TDQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsy5Rfl8PLdeX4MLNxleZIcDYOjmhDLJZkNBfK7_45rChK4Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editMM0Bpj_45meaIMQWmbzPqUuW0RYtPyb6PnNQI4bC0vXNUMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexMtrRS4PdpvWn6TMRiW2ESnP49tjlOMl_451JbB6iFLk68Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsYwDStB3PWsaQA2UnADFCiu7lGKO8Qx4TZdHuqld_45BZwMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesGnZUZn1EI2jNNrkLFtgQMhnaV0JfA2e3HDALwPkKDTsMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editP2R834CiMvQX_45G58_Y_45AfTB0HlcZr7JniXS3xhjH3EgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexDUW5U6SF8QeuC1OERkR5Y9TyFfkBpYTyzUbWNPrQEbEMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexD2wIh30Uj_avqTKCpzobZjVHVEJaaRHMMdJFMlZo6ooMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesxf_oFCogOyqa7JyqUgJfTpGQcCD8nxbZfzGXCCETlxQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editJspedUKqm1J_45oXFhNry63dhLMMISgDVnhYzL23m0oMMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profileFO4IGg4c99fogJediWJRrnEQJYVVlw0CunSqcniN2loMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actions2wHMBqtiTBrb_45pkjqOhPN8NSMULOdWx47sQznBcXYVAMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editfJoN99I_e_08JaCMH29aCj9Fxk2ol60PfA6D_45xVpuoEMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: add6DS4WJWg_4519l0UfD8Ixlu4tKJtJj_45xOJf8I7T_45s5kroMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexJ8wMmCboWYu7CFq1eruu_S7ljnWU9XbmtFgvFADvGdYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editXP_ZGrFrL9WCgKUKqprGRh76PN7O4Mk49JKCe5zUJ8YMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsHB8UxlbWfvqk72w1fPHdNaxH8d5xZFu65ewR_45FjC4pgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsIZtQkkXh3S5fMry1fCHOP9UyWmeUJeRFCcZFnfEF7vgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexinge1tEZUoetaMjt68Sh_45Y3uoRkGtIFq8sMo_of7pEhodgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: index_wcHEA2GdROFSOOYF6Zp7TgeRJXF61tHx7q4cg4CecQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editzDVOUzuQXRhN0_M2IJqe3L25u37d8CHsYkwpLgKP1g4Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexzpa3HvlmozQ39eX_IfQWPAMPOsyAbVY1INh8crEgHvQMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileZylerq96mq1EOr7q7YssNvGbdgUiPy_xoIa0GaBHNIYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexTfqeteASqnwCXMKK9IfAfw0qmGiSq_T8QqG5wP4oKhwMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editefFm_esEXHFIl1xPctCIKrzQkCSNIHebhK8Wth70YsAMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addT4sHBIFzYoqSoWR4_45QWeCgQi3_45ntExQH6vV__1J5oJ8Meta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competences6T_WcZQU_45k_yY3hAwaStXv1HHfxlgHdvgfC1I1qUDUgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferences83wyYDfGnRgJDaWBSYH4vEMAvmkO_45GA2ayq3D7YN7SEMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45userstgWWGIyUXGpVcUKKx9SCJThDTS0x9tcm4DcbHTjNbPYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresjREuRju4p5VCrXBo944v7SY3EbAGEChs30MPS5_45p6aoMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationnVpeBO743OBABCmP6a_456XVVsjPyqFMlaKHb5CnEF55YMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedTMdTJoNtuzO6Zf_FiTzptfvNprgLsuttHVKbzID_458YYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsxLI3ZeiD40bquyfxIX_45j3UOCOYlv1ub_6DzK2wRzNLwMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45roley62Z2DqU7HSHmVa2eCItVsMEF63hnuYu9sM4LEPsbscMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsbgE7DbV3h3PV_45TZuzIXjoFqocbQ8rnUCzDJL3pDfcDwMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editERaGqDAe_RiUBI7Q2_wIv9gkTpbl2F9L7ZhI3TVYGUcMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilites3LuUhhrTQVscjvcd9yLJg_SLh1ddKrf_45h22IgqFUxdEMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45link8T_45wvxKSqNKKFwfWLkf3rgty56Letp1sLCaiVFNlcfEMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: index9d_45C4MDyypT5HEjgEgRR3mj5seXpwTGd_45jqd7jHn0VgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivitegQ4dSZzNbkbbSpWUI19YsO9WYpQXiwlvlU_45AqY34JmYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationOShYUV1_gnPpsPLG7jnjlJB70O4jIMNjOuUWYO8oTXcMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsaojBh9u1z74ekbtyZa4Epr4OWQQAfUM4mFFyk5vfvqYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entranti3CjkxZXdmHQI5v1g3yZ_DpLINWH9qXA7IK2ph7_UVUMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortant_HbgiJYl9n_ro0IOlKel0MI5JNO6SPf7glDDq6GaJIYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexBFRsi0hyYLDEr1ZK9i1EMYrpCPxYDDlWWgnLRQFpvDsMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesiFq3DOSkeHJPOquE8yWI_0uqzeRWhaCJVLd907Nff9oMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45valider96iQuc8O6RhBeF7kufDOQI1bzC_45SyCaB9Yqzm28osSMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesxhsWIrK2o7cl6uJc5WPjG_2t0uybUlbr0fyaa9s7RLUMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesXfH_45Oy9VWSMCySlQduA08ACiPbHk0Q8CeK3IfzG_45ktMMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsiCgiGxHEZKTwwwencdIRKMFqbLj_WiPwlm0PvClcGPgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedMfdX7Q9QvZWT2y6sRWRhNi8G_45T8Sg3_Iaw8MEn_VHZwMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerwYX7hAzQvwd_45qDDHs4yF06e8vD51_45JCxLULM7tg1raoMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationIgfh2vHvhp8bSOTMGA_452IviKRj_451cn2F5UMnWSwZXkgMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationZv__DPWykkLdqTRDj2ov5iA0Q2jXlPiM_tXYxCp5s7EMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45valider_Ol_45aJ7INzXz6FpSvxs1EtwV9LjXy952vwDow38sVrwMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleeslDJWCuUv3sXoBysNTNU5Ps2fpUIsmTTX8TmNPhB1yeYMeta || {},
    component: () => import("/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/user/settings",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/inscription/organisation",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/statistiques",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  },
  {
    name: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6FmkMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub37bBvYaFJ2vQZZlgfvwrtNQhxLZ2ILCfXi2YLXP6Fmk
  }
]